export const backgroundColors = {
  bg_primary: '#16191f',
  bg_secondary: '#17191F',
  bg_surface: '#1F222A',
  bg_surface_3: '#282C36',
} as const

export const cardBackground = {
  card_primary: 'rgb(38 44 54 / 60%)',
  card_primary_active: 'rgb(48 51 65 / 60%)',
  card_primary_active_alt: 'rgb(52 58 74 / 60%)',
  card_subtle_overlay: 'rgb(38 44 54 / 20%)',
}
